import { Route } from '@lessonup/client-integration';

export const communityRoute = new Route('community', {}, () => `https://community.lessonup.com/feed`);
